import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: 1, title: "Share your requirement", note: "Product, indicative grade and approximate quantity." },
  { n: 2, title: "Lot check and sample", note: "We check the current lot and share photographs or a sample." },
  { n: 3, title: "Written quotation", note: "Rate, specification and validity confirmed in writing." },
  { n: 4, title: "Packing and dispatch", note: "Weighed, packed and dispatched after payment clearance." },
];

export const ProcessSummary = () => (
  <section id="supply-process" className="py-16 bg-spice-green-dark text-white px-4 sm:px-6" data-testid="process-summary-section">
    <div className="max-w-7xl mx-auto space-y-10">
      <Reveal className="max-w-2xl space-y-2">
        <span className="text-xs font-bold uppercase tracking-widest text-spice-gold">How supply works</span>
        <h2 className="text-2xl sm:text-3xl font-bold">Four Simple Steps</h2>
        <p className="text-sm text-spice-sage">
          A short, predictable process from enquiry to dispatch. The detailed nine-step workflow and payment policy are
          on the Quality &amp; Process page.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {STEPS.map((step, i) => (
          <Reveal key={step.n} delay={i * 70}>
            <div className="bg-spice-green/60 p-5 rounded border border-white/10 space-y-2 h-full" data-testid={`process-step-${step.n}`}>
              <div className="text-xs font-bold text-spice-gold">Step {step.n}</div>
              <div className="text-sm font-semibold">{step.title}</div>
              <p className="text-xs text-spice-sage leading-relaxed">{step.note}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <Link
          to="/quality-and-process"
          data-testid="process-detail-link"
          className="inline-flex items-center justify-center px-6 py-3 bg-white/10 border border-white/30 text-white text-sm font-semibold rounded-[9px] hover:bg-white/20 transition-colors"
        >
          See the full quality and process details
        </Link>
      </Reveal>
    </div>
  </section>
);
